'use strict';
Ilduomo.controller('busquedaClientesCtrl', function ($scope) {
   
   $scope.pedidos = [];
    
});